document.addEventListener('DOMContentLoaded', function(){
  const loadMoreButton = document.querySelector('.main-blog__button');
  if(loadMoreButton) {
    const wrapper = document.querySelector('.blog-articles');
    const itemsCount = loadMoreButton.getAttribute('data-items');
    const pagesCount = Math.ceil(itemsCount / 12);
    let currentPage = 1;
    if (window.location.href.includes('page')) {
      currentPage = +window.location.href[window.location.href.indexOf('page') + 5]
    }

    loadMoreButton.addEventListener('click', function() {
      fetch(window.location.pathname + `?page=${currentPage + 1}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newElements = html.querySelectorAll('.article');

        newElements.forEach(article => (
          wrapper.appendChild(article)
        ));
        currentPage++;
        if (currentPage == pagesCount) {
          loadMoreButton.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);
      });

    })
  }
  
})